/* TODO
 * Currently nothing passes the iFrameId, in the future we either need to
 * pass it, or fetch it directly from redux via some custom Middleware
 * (https://github.com/reduxjs/react-redux/issues/361) or some other solution
 */

export default function sendHeightPostMessage(iFrameId) {
  /* Chrome and Safari seem to treat documentElement and body differently when in an iFrame
   * One will get the full height of the iFrame and the other will get the height of the content
   * So instead we use the React root element to set the height
   */
  const data = {
    type: 'SET_IFRAME_HEIGHT_REQUEST',
    payload: document.getElementById('root').scrollHeight,
    iFrameId,
  };
  window.parent.postMessage(data, '*');
}
